import {
  fetchAuthSession,
  getCurrentUser,
  signOut,
  signIn,
  type SignInInput,
  UpdatePasswordInput,
  updatePassword,
} from "aws-amplify/auth";
import { validEmail } from "src/helper/validEmail";


const currentSession = async () => {
  try {
    const { accessToken, idToken } = (await fetchAuthSession()).tokens ?? {};
    const data = {
      accessToken: accessToken?.toString() as string,
      idToken: idToken?.toString() as string,
    };
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

const currentAuthenticatedUser = async () => {
  try {
    const { username, userId, signInDetails } = await getCurrentUser();
    const dataUser = {
      username: validEmail(username),
      userId,
      signInDetails,
    };
    return dataUser;
  } catch (err) {
    console.log("error data user", err);
    handleSignOut();
    localStorage.clear();
    window.location.href = '/login';
    throw err;

  }
};
const handleSignIn = async ({ username, password }: SignInInput) => {
  try {
    const { isSignedIn, nextStep } = await signIn({ username, password });
    return {
      isSignedIn,
      nextStep,
    };
  } catch (error) {
    console.log("error signing in", error);
    throw error;
  }
};

const handleSignOut = async () => {
  try {
    await signOut();
  } catch (error) {
    console.log("error signing out: ", error);
    throw error;
  }
};

const handleUpdatePassword = async ({
  oldPassword,
  newPassword,
}: UpdatePasswordInput) => {
  try {
    await updatePassword({ oldPassword, newPassword });
  } catch (err) {
    console.log(err);
  }
};

const Auth = {
  currentSession,
  currentAuthenticatedUser,
  handleSignIn,
  handleSignOut,
  handleUpdatePassword
};

export { Auth };
